import styled from "@emotion/styled";

import { fontSourceSerif4, theme } from "shared/lib/styles";

import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  block-size: 100%;
`;

export const StyledEntityLink = styled(EntityLink)`
  display: flex;
  flex: 1;
  flex-direction: column;

  color: #000000;
`;

export const CoverImage = styled.div`
  position: relative;
  ${Figure} {
    aspect-ratio: 3/2;
  }
`;

export const Content = styled.div`
  margin-block-start: 8px;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  font-family: ${fontSourceSerif4};
  line-height: 130%;
  letter-spacing: -0.32px;

  ${theme.breakpoints.up("tablet")} {
    font-weight: 500;
  }
`;
